import { PreferencesContext } from "../../contexts/PreferencesContext";




import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { withRouter, Redirect, Link } from 'react-router-dom';
import { logout } from '../../actions/AppActions';
import { connect } from 'react-redux';

// users
import moment from 'moment';
import { API_URL, THIS_URL, URL } from '../../variables';
import { maskNumber } from '../../Auxiliar/Masks';

import ReactPaginate from 'react-paginate';
import { MdEditNote, MdGroups, MdMenuBook, MdOutlineRule, MdReply, MdReport, MdShield, MdStarOutline } from 'react-icons/md';
import { Form, FormControl as Input, InputGroup, Button, Select, Spinner } from "react-bootstrap";
import ImageLoaderInput from '../ReusableComponents/ImageLoaderInput';
import Attention from '../ReusableComponents/Attention';
import { RiArrowGoBackLine, RiArrowLeftLine } from 'react-icons/ri';
import DefaultButton from '../ReusableComponents/DefaultButton';
import JoditEditor from 'jodit-react';
import TabPanel from "../ReusableComponents/TabPanel";
import TextReadMore from '../ReusableComponents/TextReadMore';
import { CircularProgress, Snackbar } from "@material-ui/core";
import ModalRegras from './ModalRegras';
import Redacoes from '../Redacoes/Redacoes';
import Provas from '../Provas/Provas';
import CandidatosVinculados from '../CandidatosVinculados/CandidatosVinculados';
import CandidatosSaidas from '../CandidatosVinculados/CandidatosSaidas';

import FiscaisVinculados from '../FiscaisVinculados/FiscaisVinculados';
import CorretoresVinculados from '../CorretoresVinculados/CorretoresVinculados';
import SalasProcesso from '../SalasProcesso/SalasProcesso';
import AnalisesCandidatos from '../AnalisesCandidatos/AnalisesCandidatos';
import Downloads from '../Downloads/Downloads';
import QuestionariosVinculados from '../QuestionariosVinculados/QuestionariosVinculados';
import Diagramacoes from '../Diagramacoes/Diagramacoes';
import AvaliadoresVinculados from '../AvaliadoresVinculados/AvaliadoresVinculados';
import Entrevista from '../Entrevista/Entrevista';
import ProcessoConfiguracoes from '../ProcessoConfiguracoes/ProcessoConfiguracoes.js';
import BlocosProcesso from '../BlocosProcesso/BlocosProcesso';
import ProcessDashboard from '../Faculdades/Dashboard/Cards/ProcessDashboard';
import './label.css';
import {
  MdCalendarMonth,
  MdOutlineDescription } from
"react-icons/md";

class ShowProcesso extends Component {static contextType = PreferencesContext;

  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      path: '/',
      loading_screen: true,
      roles: [],
      name: '',
      caminho: '',
      termos: '',
      loading_save: false,
      msgErro: '',
      loading_image: false,
      faculdade: {},
      processo: {},
      show_more: false,

      activeTab: -1,
      activeReportTab: -1
    };

  }


  get_processo(id) {

    if (this.state.loading_screen == false) {
      this.setState({ loading_screen: true });
    }
    fetch(`${URL}api/faculdade/get_processo/${id}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Authorization': `Bearer ${this.props.token}`
        // 'Content-Type': 'application/json',
      }
    }).then(async (responseLog) => {
      try {
        let resp = await responseLog.json();
        console.log(resp);
        if (resp.message == "Unauthenticated.") {
          localStorage.removeItem('token');localStorage.removeItem('user');
          // this.setState({redirect:true,path:'/'});
          this.props.logout();
          return;
        }
        if (resp.errors != null || resp.error != null) {
          let errors = Object.values(resp.errors);
          let erro = '';
          for (let i = 0; i < errors.length; i++) {
            if (i != errors.length - 1)
            erro += errors[i] + '\n';else

            erro += errors[i];
          }
          console.log(erro);
          this.setState({ redirect: true });

          //   setTimeout(()=>{
          //     this.get_processo();
          //   });
        } else
        {
          // this.props.mudarUser(resp.user);
          this.setState({
            loading_screen: false,
            faculdade: resp.processo.faculdade || {},
            processo: resp.processo
          });
        }

      } catch (err) {
        this.setState({
          redirect: true,
          loading_screen: false
        });
        console.log(err);
      }

    }).
    catch((err) => {
      this.setState({
        redirect: true,
        loading_screen: false
      });
      console.log(err);
    });
  }






  componentDidMount() {
    let params = new URLSearchParams(this.props.location.search);
    let tab = params.get('tab');
    let report = params.get('report');
    if (tab !== undefined && tab !== null) this.setState({ activeTab: parseInt(tab) });else
    if (tab === null) this.setState({ activeTab: -1 });
    if (report !== undefined && report !== null) this.setState({ activeReportTab: parseInt(report), activeTab: -1 });
    this.get_processo(this.props.match.params.id);
  }

  getQuickReportActions = () => [
  { id: 0, icon: '📋', title: this.context.t("title_general_logs"), description: this.context.t("legacy_acompanhe_acessos_e_eventos_registrados_durante_a_avaliacao") },
  { id: 1, icon: '🟢', title: this.context.t("legacy_online_agora"), description: this.context.t("legacy_veja_candidatos_e_avaliadores_conectados_no_momento") },
  { id: 2, icon: '↗', title: this.context.t("legacy_saidas_de_tela"), description: this.context.t("legacy_confira_registros_de_troca_de_janela_ou_saida_da_tela") },
  { id: 3, icon: '🙂', title: this.context.t("legacy_analise_facial"), description: this.context.t("legacy_revise_validacoes_imagens_e_ocorrencias_de_reconhecimento_facial") },
  { id: 4, icon: '🧭', title: this.context.t("legacy_movimento_facial"), description: this.context.t("legacy_analise_movimentacoes_capturadas_pela_camera") },
  { id: 5, icon: 'ⓘ', title: this.context.t("title_reliability"), description: this.context.t("legacy_acompanhe_indicadores_de_confianca_dos_candidatos") },
  { id: 6, icon: '🤖', title: this.context.t("video_ai_report_title"), description: this.context.t("video_ai_report_description") }];


  openQuickReport = (reportId) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.setState({
      activeTab: -1,
      activeReportTab: reportId
    });
    this.props.history.push({ search: `?report=${reportId}` });
  };

  closeQuickReport = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.setState({ activeReportTab: -1 });
    this.props.history.push({ search: '' });
  };




componentDidUpdate(prevprops,prevState){
    if(prevState.activeTab!=-1 && this.state.activeTab==-1){
      this.props.history.push({ search: '' });
    }
  }


  render() {
    if (this.state.loading_screen) return <SkeletonCoursePage />;

    // Verificar se os dados necessários foram carregados
    if (!this.state.processo) {
      return <SkeletonCoursePage />;
    }

    const modules = [
    ...(this.state.processo.has_blocks === true ? [{
      icon: "⏱️",
      title: this.context.t("title_blocks"),
      description: this.context.t("description_manage_blocks"),
      tab: 11
    }] : []),
    ...(!this.state.processo.is_interview ? [{
      icon: "📝",
      title: this.context.t("essays"),
      description: this.context.t("legacy_gerencie_as_redacoes"),
      tab: 0
    },
    {
      icon: "📚",
      title: this.context.t("tests"),
      description: this.context.t("legacy_gerencie_provas_e_itens"),
      tab: 1
    },
    {
      icon: "📄",
      title: this.context.t("diagramLayouts"),
      description: this.context.t("legacy_gerencie_diagramacoes"),
      tab: 2
    },
    {
      icon: "❓",
      title: this.context.t("questionnaires"),
      description: this.context.t("legacy_gerencie_questionarios"),
      tab: 3
    },
    {
      icon: "🏢",
      title: this.context.t("rooms"),
      description: this.context.t("legacy_gerencie_salas"),
      tab: 4
    },
    {
      icon: "👨‍🏫",
      title: this.context.t("graders"),
      description: this.context.t("legacy_gerencie_corretores"),
      tab: 5
    },
    {
      icon: "🛡️",
      title: this.context.t("proctors"),
      description: this.context.t("legacy_gerencie_fiscais"),
      tab: 6
    }] : []),
    {
      icon: "👥",
      title: this.context.t("candidates"),
      description: this.context.t("legacy_gerencie_candidatos"),
      tab: 7
    },


    ...(this.state.processo.is_interview ? [{
      icon: "🎤",
      title: this.context.t("ui_avaliacao_oral_f015a022"),
      description: this.context.t("ui_configuracoes_da_avaliacao_oral_f1c2d588"),
      tab: 9
    },
    {
      icon: "⭐",
      title: this.context.t("evaluators"),
      description: this.context.t("ui_gerencie_avaliadores_00986d21"),
      tab: 8
    }] :
    []),
    {
      icon: "⚙️",
      title: this.context.t("legacy_configuracoes"),
      description: this.context.t("legacy_configuracoes_do_processo"),
      tab: 10
    }];


    const agora = moment();

    const inicio = moment(this.state.processo.inicio);
    const fim = moment(this.state.processo.fim);

    let status = this.context.t("status_pending");
    let statusClass = "status-pendente";

    if (agora.isBetween(inicio, fim, null, '[]')) {
      status = this.context.t("status_in_progress");
      statusClass = "status-andamento";
    } else
    if (agora.isAfter(fim)) {
      status = this.context.t("status_finished");
      statusClass = "status-finalizado";
    }

    const reportActions = this.getQuickReportActions();
    const selectedReport = reportActions.find((report) => report.id === this.state.activeReportTab);
    const dashboardMode = this.state.activeTab === -1 && this.state.activeReportTab === -1;

    return (
      <div style={{ position: "relative" }}>
        <div className="processo-page">
          <div className="process-breadcrumb">

            <Link to="/">
              {this.props.user.empresa == null || this.props.user.empresa.change_text == false ? this.context.t("title_institution") : this.context.t("title_process")}

            </Link>

            <span>›</span>

            <Link
              to={`/instituicao/show/${this.state.processo.faculdade_id}`}>

              {this.state.faculdade?.name}
            </Link>

            <span>›</span>

            <span>
              {this.state.processo.name}
            </span>

          </div>
          <div className="process-reports-panel hidethis">
          <div className="process-header ">

            <div>

              <h1>
                {this.state.processo.name}
              </h1>

              <div className={`status-badge ${statusClass}`}>

                <span className="status-dot"></span>

                {status}

              </div>
            </div>

            <Link
              to={`/instituicao/show/${this.state.processo.faculdade_id}?tab=0`}
              className="btn-back-modern">


              <RiArrowLeftLine />{`

              ${this.context.t("action_back")}

            `}</Link>

          </div>

          <div className="process-info-grid">

            <div className="process-info-card">

              <div className="icon blue">
                <MdCalendarMonth />
              </div>

              <div>
                <span>{this.context.t("label_start")}</span>

                <strong>
                  {moment(
                    this.state.processo.inicio
                  ).format("DD/MM/YYYY HH:mm")}
                </strong>
              </div>

            </div>

            <div className="process-info-card">

              <div className="icon orange">
                <MdCalendarMonth />
              </div>

              <div>
                <span>{this.context.t("label_end")}</span>

                <strong>
                  {moment(
                    this.state.processo.fim
                  ).format("DD/MM/YYYY HH:mm")}
                </strong>
              </div>

            </div>

            <div className="process-info-card">

              <div className="icon cyan">
                <MdOutlineDescription />
              </div>

              <div>
                <span>{this.context.t("label_proctoring_type")}</span>

                <strong>
                  {this.state.processo.type_fiscalization == 'all' ? this.context.t("label_save_videos_streaming") : this.state.processo.type_fiscalization == 'image' ? this.context.t("legacy_salvar_imagens_com_streaming_em_tempo_real") : this.context.t("legacy_sem_fiscalizacao")}
                </strong>
              </div>

            </div>

            <div
              className="process-info-card clickable"
              onClick={() =>
              this.setState({
                show_more: true
              })
              }>


              <div className="icon green">
                <MdOutlineRule />
              </div>

              <div>
                <span>{this.context.t("label_rules")}</span>

                <strong>{this.context.t("legacy_ver_regras")}</strong>
              </div>

            </div>

          </div>
</div>




          {/* <div style={{ width: "100%", marginBottom: 10, whiteSpace: 'pre',height:this.state.show_more==false?100:'fit-content',overflowY:this.state.show_more==false? 'hidden':'visible' }}>
                               <b style={{ float: "left", marginRight: "2px" }}>{'Regras:'} </b>
                               <br/>
                               <div className="jodit-wysiwyg" dangerouslySetInnerHTML={{ __html: this.state.processo.regras }}>
                               </div>
                           </div> */}
          {/* <div className="w100 flex align-center fdcolumn margin-bottom">
                               <div className="course-banner" style={{
                                   backgroundImage: `url(${STORAGE_URL+ this.state.faculdade.logo})`,
                                   backgroundSize: "contain",
                                   backgroundRepeat:'no-repeat',
                                   backgroundPositionX:'center',
                                   width: "100%",
                                   height: "200px",
                                   borderRadius: "7px"
                               }} />
                           </div> */}
          {/* <br className='hidethis' />
                           <br className='hidethis' /> */}

          <ModalRegras
            showModal={this.state.show_more}
            setShowModal={(e) => this.setState({ show_more: e })}
            processo_name={this.state.processo.name}
            regras={this.state.processo.regras} />

          {this.state.activeReportTab !== -1 && selectedReport &&
          <div className="process-report-view">
              <div className="process-report-header">
                <div>
                  <span className="process-report-eyebrow">{this.context.t("legacy_relatorio_rapido")}</span>
                  <h3>{selectedReport.title}</h3>
                  <p>{selectedReport.description}</p>
                </div>

                <button
                type="button"
                className="btn-back-modern"
                onClick={this.closeQuickReport}>

                  <RiArrowGoBackLine />{`
                  ${this.context.t("action_back")}
                `}</button>
              </div>

              <ProcessDashboard
              processo_id={this.state.processo.id}
              initialTab={this.state.activeReportTab}
              hideHeader
              hideReportButtons />

            </div>
          }

          {dashboardMode &&
          <>
              {this.props.user?.empresa?.online_proccess == true && this.state.processo.online != false &&
            <div className="process-reports-panel hidethis">
                  <div className="process-reports-header">
                    <div>
                      <h5 className="section-title">{this.context.t("title_quick_reports")}</h5>
                      <p>{this.context.t("desc_quick_reports_process")}</p>
                    </div>
                  </div>

                  <div className="process-report-grid">
                    {reportActions.map((report) =>
                <button
                  key={report.id}
                  type="button"
                  className="process-report-card"
                  onClick={() => this.openQuickReport(report.id)}>

                        <span>{report.icon}</span>
                        <strong>{report.title}</strong>
                        <small>{report.description}</small>
                      </button>
                )}
                  </div>
                </div>
            }

            </>}

              {this.state.activeReportTab === -1 && <div className="hidethis">
                <div className="modules-container">

                  <h5 className="section-title">{`
                    ${this.context.t("title_choose_module_manage")}
                  `}</h5>

                  <div className="modules-grid">

                    {modules.map((module) =>

                  <div
                    key={module.tab}
                    className={
                    this.state.activeTab === module.tab ?
                    "module-card active" :
                    "module-card"
                    }
                    onClick={() => {

                      this.setState({
                        activeTab: module.tab
                      });

                      this.props.history.push({
                        search: `?tab=${module.tab}`
                      });

                    }}>


                        <div className="module-icon">
                          {module.icon}
                        </div>

                        <div>

                          <h6>{module.title}</h6>

                          <p>{module.description}</p>

                        </div>

                      </div>

                  )}

                  </div>

                </div>
              </div>}

            {dashboardMode &&
            <>
              <div className="summary-container hidethis">

                <div className="summary-left">

                  <h4>{this.context.t("title_quick_summary")}</h4>

                  <div className="summary-cards">

                    <div className="summary-card">

                      <div className="summary-icon purple">
                        <MdEditNote />
                      </div>

                      <div className="summary-number">
                        {this.state.total_essay ?? '-'}
                      </div>

                      <div className="summary-label">{`
                        ${this.context.t("legacy_redacoes_cadastradas")}
                      `}</div>

                    </div>

                    <div className="summary-card">

                      <div className="summary-icon blue">
                        <MdMenuBook />
                      </div>

                      <div className="summary-number">
                        {this.state.total_exams ?? '-'}
                      </div>

                      <div className="summary-label">{`
                        ${this.context.t("legacy_provas_cadastradas")}
                      `}</div>

                    </div>

                    <div className="summary-card">

                      <div className="summary-icon green">
                        <MdGroups />
                      </div>

                      <div className="summary-number">
                        {this.state.total_candidates ?? '-'}
                      </div>

                      <div className="summary-label">{`
                        ${this.context.t("legacy_candidatos_vinculados")}
                      `}</div>

                    </div>

                    <div className="summary-card">

                      <div className="summary-icon orange">
                        <MdShield />
                      </div>

                      <div className="summary-number">
                        {this.state.total_proctors ?? '-'}
                      </div>

                      <div className="summary-label">{`
                        ${this.context.t("legacy_fiscais_vinculados")}
                      `}</div>

                    </div>

                    <div className="summary-card">

                      <div className="summary-icon orange">
                        <MdStarOutline />
                      </div>

                      <div className="summary-number">
                        {this.state.total_evaluators ?? '-'}
                      </div>

                      <div className="summary-label">{`
                        ${this.context.t("legacy_avaliadores_vinculados")}
                      `}</div>

                    </div>

                  </div>

                </div>

                <div className="summary-right">

                  <h4>{this.context.t("title_latest_updates")}</h4>

                  <div className="activity-list">

                    <div className="activity-item">
                      <span className="activity-dot"></span>{`
                      ${this.context.t("legacy_redacao_criada")}
                    `}</div>

                    <div className="activity-item">
                      <span className="activity-dot"></span>{`
                      ${this.context.t("legacy_prova_atualizada")}
                    `}</div>

                    <div className="activity-item">
                      <span className="activity-dot"></span>{`
                      ${this.context.t("legacy_candidato_vinculado")}
                    `}</div>

                  </div>

                </div>

              </div>
            </>}

          <TabPanel value={this.state.activeTab} padding={0} index={0}>
            <Redacoes
              setState={(data) => this.setState(data)}
              processo_id={this.state.processo.id}
              processo_name={this.state.processo.name}
              simulado={this.state.processo.simulado}
              has_blocks={this.state.processo.has_blocks === true} />

          </TabPanel>
          <TabPanel value={this.state.activeTab} padding={0} index={1}>
            {/* <Corretores faculdade_id={this.state.faculdade.id} faculdade_name={this.state.faculdade.name} /> */}
            <Provas
              setState={(data) => this.setState(data)}

              processo_id={this.state.processo.id}
              inicio={this.state.processo.inicio}
              processo_name={this.state.processo.name}
              simulado={this.state.processo.simulado}
              has_blocks={this.state.processo.has_blocks === true} />

          </TabPanel>

          <TabPanel value={this.state.activeTab} padding={0} index={2}>
            <Diagramacoes
              setState={(data) => this.setState(data)}

              processo_id={this.state.processo.id}
              processo_name={this.state.processo.name} />

          </TabPanel>

          {
          <TabPanel value={this.state.activeTab} padding={0} index={3}>
              {/* <Corretores faculdade_id={this.state.faculdade.id} faculdade_name={this.state.faculdade.name} /> */}
              {/* <Provas processo_id={this.state.processo.id} processo_name={this.state.processo.name} /> */}
              {this.props.user?.empresa?.online_proccess == true &&
            this.props.user.id != undefined && (
            this.props.user.role == "region_admin" ||
            this.props.user.empresa == null ||
            this.props.user.empresa.hide_questionario == false) &&
            <QuestionariosVinculados
              setState={(data) => this.setState(data)}

              simulado={this.state.processo.simulado}
              processo_id={this.state.processo.id}
              processo_name={this.state.processo.name}
              has_blocks={this.state.processo.has_blocks === true} />

            }
              {(this.props.user?.empresa?.online_proccess == false ||
            !(
            this.props.user.role == "region_admin" ||
            this.props.user.empresa == null ||
            this.props.user.empresa.hide_questionario == false)) &&

            <div>
                    <p style={{ textAlign: "center" }}>{this.context.t("ui_modulo_nao_habilitado_f5792cfe")}

              </p>
                  </div>
            }
            </TabPanel>
          }
          {
          <TabPanel value={this.state.activeTab} padding={0} index={4}>
              {/* <AddToCourse/> */}
              {/* <Fiscais faculdade_id={this.state.faculdade.id} faculdade_name={this.state.faculdade.name} /> */}
              <SalasProcesso
              setState={(data) => this.setState(data)}

              processo_id={this.state.processo.id}
              processo_name={this.state.processo.name} />

            </TabPanel>
          }
          {
          <TabPanel value={this.state.activeTab} padding={0} index={5}>
              {/* <AddToCourse/> */}
              {/* <Fiscais faculdade_id={this.state.faculdade.id} faculdade_name={this.state.faculdade.name} /> */}
              <CorretoresVinculados
              setState={(data) => this.setState(data)}

              processo_id={this.state.processo.id}
              processo_name={this.state.processo.name} />

            </TabPanel>
          }
          {
          <TabPanel value={this.state.activeTab} padding={0} index={6}>
              {/* <AddToCourse/> */}
              {/* <Fiscais faculdade_id={this.state.faculdade.id} faculdade_name={this.state.faculdade.name} /> */}
              {!(
            this.props.user?.empresa?.online_proccess == false ||
            this.state.processo.online == false) &&

            <FiscaisVinculados
              setState={(data) => this.setState(data)}

              processo_id={this.state.processo.id}
              processo_name={this.state.processo.name} />

            }
              {(this.props.user?.empresa?.online_proccess == false ||
            this.state.processo.online == false) &&
            <p style={{ textAlign: "center" }}>{this.context.t("ui_modulo_nao_habilitado_f5792cfe")}

            </p>
            }
            </TabPanel>
          }
          {
          <TabPanel value={this.state.activeTab} padding={0} index={7}>
              {/* <Alunos faculdade_id={this.state.faculdade.id} faculdade_name={this.state.faculdade.name} /> */}
              <CandidatosVinculados
              setState={(data) => this.setState(data)}

              online={this.state.processo.online}
              processo_id={this.state.processo.id}
              processo_name={this.state.processo.name}
              faculdade={this.state.faculdade} />

            </TabPanel>
          }

          <TabPanel value={this.state.activeTab} padding={0} index={8}>
            {/* <Corretores faculdade_id={this.state.faculdade.id} faculdade_name={this.state.faculdade.name} /> */}
            <AvaliadoresVinculados
              setState={(data) => this.setState(data)}

              processo_id={this.state.processo.id}
              inicio={this.state.processo.inicio}
              processo_name={this.state.processo.name}
              simulado={this.state.processo.simulado} />

          </TabPanel>

         

          {this.state.processo.is_interview &&
          <TabPanel value={this.state.activeTab} padding={0} index={9}>
              {/* <Corretores faculdade_id={this.state.faculdade.id} faculdade_name={this.state.faculdade.name} /> */}
              <Entrevista
              setState={(data) => this.setState(data)}

              processo_id={this.state.processo.id}
              inicio={this.state.processo.inicio}
              processo_name={this.state.processo.name} />

            </TabPanel>
          }

           <TabPanel value={this.state.activeTab} padding={0} index={10}>
            {this.props.user?.empresa?.plan?.training == true ? <ProcessoConfiguracoes
              setState={(data) => this.setState(data)}

              processo_id={this.state.processo.id}
              processo_name={this.state.processo.name} /> :

            <p style={{ textAlign: "center" }}>{this.context.t("ui_modulo_nao_habilitado_f5792cfe")}

            </p>}
          </TabPanel>

          {this.state.processo.has_blocks === true &&
          <TabPanel value={this.state.activeTab} padding={0} index={11}>
              <BlocosProcesso
              setState={(data) => this.setState(data)}
              processo_id={this.state.processo.id}
              processo_name={this.state.processo.name} />
            </TabPanel>}

          {/* {this.state.processo.online==true && <TabPanel value={this.state.activeTab} index={8}>
                               <CandidatosSaidas processo_id={this.state.processo.id} processo_name={this.state.processo.name} />
                            </TabPanel>}
                              {this.state.processo.online==true && <TabPanel value={this.state.activeTab} index={9}>
                               <AnalisesCandidatos processo_id={this.state.processo.id} processo_name={this.state.processo.name} />
                            </TabPanel>}
                             {this.state.processo.online==true && <TabPanel value={this.state.activeTab} index={11}>
                               <Downloads processo_id={this.state.processo.id} processo_name={this.state.processo.name} />
                            </TabPanel>} */







          }
        </div>
      </div>);

  }


}
const mapsStateToProps = (state) => (
{
  token: state.AppReducer.token,
  user: state.AppReducer.user

});


const SkeletonCoursePage = () => {
  return (
    <div className="card">
      <div className="card-body">
        <div className="skeleton-title" />
        {/* <div className="skeleton-small-text skeleton-shimmer"/>
                   <div className="skeleton-small-text skeleton-shimmer"/> */}
        <br />
        <div className="w100 flex jcc align-center">
          <div className="skeleton-base skeleton-shimmer" style={{ width: "12em", height: "12em" }} />
        </div>
        <br />
        <div className="w100 skeleton-base skeleton-shimmer margin-bottom" style={{ minHeight: "48px" }} />
        <div className="w100 skeleton-base skeleton-shimmer margin-bottom" style={{ minHeight: "5em" }} />
        <div className="skeleton-small-button skeleton-shimmer" />
      </div>
    </div>);

};

export default connect(mapsStateToProps, { logout })(ShowProcesso);
